import { render, staticRenderFns } from "./GainOnSale3.vue?vue&type=template&id=20bf5a7d&"
import script from "./GainOnSale3.vue?vue&type=script&lang=js&"
export * from "./GainOnSale3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports